// src/components/ProtectedRoute/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { currentUser } = useAuth();

  // If no user is logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole) {
    // had iyo jeer ka dhig array
    const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

    // check haddii user.role ku jiro list-ka roles
    if (!roles.includes(currentUser.role)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // User has required role or no role required
  return children;
};

export default ProtectedRoute;
